// extracted by mini-css-extract-plugin
export default {"parent":"login_parent__bC3wH","sub":"login_sub__VWlpn","input":"login_input__kKVsN","signup":"login_signup__w5jd1"};